'use strict'

const getMETPrice = () =>
  fetch(
    'https://api.coingecko.com/api/v3/simple/price?ids=metronome&vs_currencies=usd'
  )
    .then(res => res.json())
    .then(res => res.metronome.usd)

module.exports = {
  getMETPrice
}
